import { Close } from '@radix-ui/react-dialog';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import logo from '@/assets/img/dobrozem-member.svg';
import { CloseIcon } from '@/assets/react-icons/CloseIcon';
import { Button } from '../Button';
import { ConsultationModal } from '../ConsultationModal';
import { Modal } from '../Modal';
import { OfferModalBtn } from '../OfferModalBtn';
import { Text } from '../Text';
import styles from './InDevelopmentModal.module.scss';
type Props = {
  className?: string;
  onClose: () => void;
  open: boolean;
};
export const InDevelopmentModal = ({
  className,
  onClose,
  open
}: Props) => {
  const [isOpenConsultationModal, setOpenConsultationModal] = useState(false);
  const handleOpenChange = () => {
    setOpenConsultationModal(prevState => !prevState);
  };
  return <>
      <Modal className={clsx(styles.wrapper, className)} contentClassName={styles.content} onOpenChange={onClose} open={open} data-sentry-element="Modal" data-sentry-source-file="InDevelopmentModal.tsx">
        <Close className={styles.closeBtn} data-sentry-element="Close" data-sentry-source-file="InDevelopmentModal.tsx">
          <CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="InDevelopmentModal.tsx" />
        </Close>
        <Image alt='dobrozem' className={styles.logo} src={logo} data-sentry-element="Image" data-sentry-source-file="InDevelopmentModal.tsx" />
        <Text className={styles.description} type='h2' data-sentry-element="Text" data-sentry-source-file="InDevelopmentModal.tsx">
          Даний функціонал в розробці
        </Text>
        <div className={styles.btns}>
          <Link href={'/'} onClick={onClose} data-sentry-element="Link" data-sentry-source-file="InDevelopmentModal.tsx">
            <Button asDiv fullWIdth data-sentry-element="Button" data-sentry-source-file="InDevelopmentModal.tsx">
              Перейти на головну
            </Button>
          </Link>
          {/* <Button bordered fullWIdth onClick={() => setOpenConsultationModal(true)}>
            Звʼязатись з нами
           </Button> */}
          <OfferModalBtn buttonLarge className={styles.contactUsBtn} isFull label='Звʼязатись з нами' data-sentry-element="OfferModalBtn" data-sentry-source-file="InDevelopmentModal.tsx" />
        </div>
      </Modal>
      <ConsultationModal isOpen={isOpenConsultationModal} onOpenChange={handleOpenChange} data-sentry-element="ConsultationModal" data-sentry-source-file="InDevelopmentModal.tsx" />
    </>;
};